import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogOptions, DialogService } from '../../services/modal-dialogs';
import { Invoice } from '../../models/domain/invoice';
import { ssApiService } from '../../../app/services/ss-api.service';
import { GetGatewayLogParsesRequest, GetGatewayLogParsesRequestTypes } from '../../../app/models/ss-api/requests/get.gateway.log.parses.request';
import { GatewayLogParse, GatewayLogParseArray } from '../../../app/models/domain/gateway.log.parse';
import { Router } from '@angular/router';
import { InvoiceRefundableStatusResponse } from '@models/ss-api/responses/invoice.refundable.status.response';
import { InvoiceRefundRequest } from '@models/ss-api/requests/invoice.refund.request';
import { SweetAlertService } from 'ng2-cli-sweetalert2';

export interface IInvoiceDetailsDialogModel {
    title: string;
    subTitle: string;
    message: string;
    invoiceItem: Invoice;
    memberName: string;
}

@Component({
    selector: 'invoice-details-dialog',
    styleUrls: ['./invoice.details.dialog.css'],
    templateUrl: './invoice.details.dialog.html'
})
export class InvoiceDetailsDialog extends DialogComponent<IInvoiceDetailsDialogModel, boolean> implements IInvoiceDetailsDialogModel, OnInit {

    IsBusy: boolean;
    title: string;
    subTitle: string;
    message: string;
    invoiceItem: Invoice;
    GatewayLogs: GatewayLogParseArray = new GatewayLogParseArray();
    TransactionIDPaid: string;

    memberName: string = '';

    RefundableStatus: InvoiceRefundableStatusResponse = new InvoiceRefundableStatusResponse();
    RefundVisible: boolean = false;
    RefundDescription: string = "Refund";
    RefundableAmount: number = 0;
    RefundableAmountReadOnly: boolean = false;
    ToggleRefundButtonText: string = "Refund"
    ShowRefundButton: boolean = false;
    ShowRefundableAmountInfo: boolean = false;
    ProcessRefundButtonText: string = "Process Refund";
    ShowProcessRefundButton: boolean = true;
    RefundableAmountInfo: string = "";
    RefundReason: string = "";
    
    constructor(dialogService: DialogService, private api: ssApiService, public router: Router, private sweetAlertService: SweetAlertService,) {
        super(dialogService, router);
    }

    ngOnInit() {
        let disposable = this.api.getMemberDashboard(this.invoiceItem.MemberID).subscribe(response => {
            this.memberName = response.Data.FirstName + ' ' + response.Data.LastName;
            disposable.unsubscribe();
        })

        if (this.GetInvoiceTotal() == 0)
        {
            this.ShowRefundButton = false;
        }
        else
        {
            this.ShowRefundButton = true;
        }

      
        this.GetGatewayLogs();
    }

    async ProcessRefundAsync(){


      
      let request: InvoiceRefundRequest = 
      {
        InvoiceID: this.invoiceItem.InvoiceID,
        Amount: this.RefundableAmount,
        ItemDescription: this.RefundDescription,
        Reason: this.RefundReason
      }

     if (!this.RefundReason) {
        this.sweetAlertService.swal(
            {
                title: 'Error',
                text: "You must provide a refund reason",
                type: 'error',
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText: 'OK',
            })
            .then((response: any) => {
                this.result = false;
                this.IsBusy = false;
            }, (dismiss) => {
                this.IsBusy = false;
                return;
            }); // keep this line to prevent promise error;        

        return;
     }       

      console.log("Request", request);

      await this.sweetAlertService.swal(
        {
            title: 'Process Refund?',
            text: 'Are you sure you want to process this refund?',
            type: 'warning',
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: 'Yes, process!',
            cancelButtonText: 'Cancel',
            allowOutsideClick: false,
            showLoaderOnConfirm: true,            
            preConfirm: () => {                
                this.IsBusy = true;
                return this.api.InvoiceRefund(request).toPromise();
            }
        })
        .then(response => {
            this.result = true;
            this.close();
            if (response.Result) {
                this.sweetAlertService.swal(
                    {
                        title: 'Success!',
                        text: 'Refund Processed',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1500
                    })
                    .then((response: any) => {
                        this.IsBusy = false;
                        return;

                    }, (dismiss) => {
                        this.IsBusy = false;
                        return;
                    }); // keep this line to prevent promise error;
            } else {
                this.sweetAlertService.swal(
                    {
                        title: 'Error!',
                        text: response.message,
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: true
                    })
                    .then((response: any) => {
                        this.IsBusy = false;
                        return;

                    }, (dismiss) => {
                        this.IsBusy = false;
                        return;
                    }); // keep this line to prevent promise error;
            }
        }, (dismiss) => {
            // this.IsBusy = false;
            return;
        })
        .catch(error => {
            this.sweetAlertService.swal(
                {
                    title: 'Error',
                    text: error.message,
                    type: 'error',
                    showCancelButton: false,
                    showConfirmButton: true,
                    confirmButtonText: 'OK',
                })
                .then((response: any) => {
                    this.result = false;
                    this.IsBusy = false;
                    this.close();
                }, (dismiss) => {
                    this.IsBusy = false;
                    return;
                }); // keep this line to prevent promise error;
        });

    }

    GetInvoiceTotal(){
        return this.invoiceItem.Total + this.invoiceItem.Credit;
    }

    GetNewInvoiceTotal(){

        let invoiceTotal = this.GetInvoiceTotal();

        let refund = this.RefundableAmount;
        if (refund <= 0)
            refund = invoiceTotal;           

        var newTotal = invoiceTotal - this.RefundableAmount;
        if (newTotal < 0)
            return 0;
        else
            return newTotal;
    }

    GetSubtotal(){
        return this.invoiceItem.SubTotal - this.invoiceItem.Credit;
    }

    GetRefundableCalculation(){
        let request: InvoiceRefundRequest = {
            InvoiceID: this.invoiceItem.InvoiceID,
            Amount: 0,
            ItemDescription: "",
            Reason: "check"
        }
       
        console.log("Invoice Item: ", this.invoiceItem);
        console.log("Request: ", request);

        this.IsBusy = true;

        let disposable = this.api.InvoiceRefundableStatus(request).subscribe(response => {
            this.RefundableStatus = response.Data;

            this.IsBusy = false;
            console.log("Refundable Status: ", this.RefundableStatus);
            disposable.unsubscribe();


            if (response.Data.TotalRefundable == 0){
                this.sweetAlertService.swal(
                    {
                        title: 'Not Refundable!',
                        text: 'This invoice is not refundable or is already refunded.',
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1500
                    })
                    .then((response: any) => {
                        
                        this.ToggleRefundButtonText = "Refund";
                        this.RefundVisible = false;
                        this.ShowProcessRefundButton = false;
                        return;

                    }, (dismiss) => {
                        this.IsBusy = false;
                        return;
                    }); // keep this line to prevent promise error;
            }
            else
            {

                if (!this.RefundableStatus.IsSettled){
                    this.RefundableAmount = this.RefundableStatus.TotalRefundable;
                    this.RefundableAmountReadOnly = true;
                    this.ShowRefundableAmountInfo = true;
                    this.RefundableAmountInfo = "Only VOID available (not settled)";
                    this.ProcessRefundButtonText = "VOID";
                }
                else{
                    this.RefundableAmount = 0;
                    this.RefundableAmountReadOnly = false;
                    this.ShowRefundableAmountInfo = false;
                    this.SetShowProcessRefundButton();
                    this.ShowRefundButton = true;
                    this.ProcessRefundButtonText = "Process Full Refund";
                }
        

            }

        })
    }

    HideProcessRefundButton(message: string){

        this.ShowProcessRefundButton = false;
        this.ShowRefundableAmountInfo = true;
        this.RefundableAmountInfo = message;
    }

    SetShowProcessRefundButton(){
        this.ShowProcessRefundButton = true;
        this.ShowRefundableAmountInfo = true;
        this.RefundableAmountInfo = "";
    }

    onRefundAmountChanged(event: string){

        if (event.startsWith("-"))
        {
            this.HideProcessRefundButton("Invalid Amount");
            return;
        }

        
        console.log("Refundable Amount", this.RefundableAmount);
        console.log("Invoice Total", this.invoiceItem.Total);
        console.log("invoice Credit", this.invoiceItem.Credit);

        let amount = Number(event);

        let invoiceAmount = this.GetInvoiceTotal();

        if (amount > invoiceAmount){
            this.HideProcessRefundButton("Amount cannot exceed the total refundable invoice amount");
            return;
        }
        else{
            this.SetShowProcessRefundButton();
        }


        if (amount == 0 || amount == invoiceAmount)
            this.ProcessRefundButtonText = "Process Full Refund";
        else 
            this.ProcessRefundButtonText = "Process Partial Refund";
    }

    GetGatewayLogs() {
        let request: GetGatewayLogParsesRequest = {
            GetGatewayLogParsesRequestType: GetGatewayLogParsesRequestTypes.Invoice,
            ID: this.invoiceItem.InvoiceID,
            LiveCheckIsSettled: true
        }
       

        let disposable = this.api.GetGatewayLogParses(request).subscribe(response => {
            this.GatewayLogs = response.Data;

            console.log("Gateway Logs received", this.GatewayLogs);

            if (this.GatewayLogs != undefined && this.GatewayLogs.length > 0)
            {
                this.GatewayLogs.forEach(x=>
                {
                    if (x.Result == "Success")
                    {
                        this.TransactionIDPaid = x.PNRef;
                        console.log("Paid Log Found", x);
                    }
                })

                //var total = this.GatewayLogs.map(x=>x.Amount).reduce((a,b)=>a+b);
                //console.log("TOTAL: ", total);              
                    
            }
            else
            {
                if (this.invoiceItem.Credit != 0)
                    this.ShowRefundButton = true;
            }
            disposable.unsubscribe();
        })
    }

    confirm() {
        // we set dialog result as true on click on confirm button,
        // then we can get dialog result from caller code
        this.result = true;
        this.close();
    }

    ToggleShowRefund() {
       

        if (!this.RefundVisible){
            this.GetRefundableCalculation();
            this.ToggleRefundButtonText = "View Invoice Details"
        }
        else{
            this.ToggleRefundButtonText = "Refund";
        }

        this.RefundVisible = !this.RefundVisible;
    }

}
